export enum CrudStoreItemPartner360 {
  JBPProductLines = 'JBPProductLines',
  PartnerDevicesInfo = 'PartnerDevicesInfo',
  PartnerMarketInfo = 'PartnerMarketInfo',
  PartnerMarketLeasing = 'PartnerMarketLeasing',
  ProgramsManagementAdmin = 'ProgramsManagementAdmin',
  ProgramsManagementPartner = 'ProgramsManagementPartner',
  PartnerBasicInfo = 'PartnerBasicInfo',
  JBPBasicInfo = 'JBPBasicInfo',
  ActionsPlan = 'ActionsPlan',
  Commitment = 'Commitment',
  GeoMapping = 'GeoMapping',
  JBPProductsTree = 'JBPProductsTree',
  JBPCommitmentLogView = 'JBPCommitmentLogView',
  PartnerTargets = 'PartnerTargets',
  PartnerSales = 'PartnerSales',
  CompensationScheme = 'CompensationScheme',
  LookupTool = 'LookupTool',
  JBPSettings = 'JBPSettings',
  JBPExportMappings = 'JBPExportMappings',
  CompletenessJBP = 'CompletenessJBP',
  JBPThingsToImprove = 'JBPThingsToImprove',
  PartnerContacts = 'PartnerContacts',
  JBPPartnerContactsHierarchy = 'JBPPartnerContactsHierarchy',
  MIFCompensation = 'MIFCompensation',
  JBPSales = 'JBPSales',
  JBPActualsAndTargetsCategories = 'JBPActualsAndTargetsCategories',
  JBPActuals = 'JBPActuals',
  JBPActualsByOffering = 'JBPActualsByOffering',
  JBPAmplifyImpactInfo = 'JBPAmplifyImpactInfo',
  JBPTargetsByOffering = 'JBPTargetsByOffering',
  JBPTargetsByOfferingV2 = 'JBPTargetsByOfferingV2',
  JBPActualsAndPlans = 'JBPActualsAndPlans',
  JBPMIFActuals = 'JBPMIFActuals',
  JBPDaasSummary = 'JBPDaasSummary',
  JBPQBRDocument = 'JBPQBRDocument',
  JbpQbrAttachments = 'JbpQbrAttachments',
  HPContacts = 'HPContacts',
  JBPSalesTeam = 'JBPSalesTeam',
  JBPHPContactChangeRequest = 'JBPHPContactChangeRequest',
  JBPHPContactRoles = 'JBPHPContactRoles',
  TopPartnerSummary = 'TopPartnerSummary',
  JBPTopPartners = 'JBPTopPartners',
  PartnerMasterDealer = 'PartnerMasterDealer',
  ThirdPartySolutions = '3rdPartySolutions',
  JBPTopTargetAccounts = 'JBPTopTargetAccounts',
  JBPProgramsManagementPartner = 'JBPProgramsManagementPartner',
  PartnerSalesScheme = 'PartnerSalesScheme',
  GeneralPlanning = 'GeneralPlanning',
  DaaSPlanActuals = 'DaaSPlanActuals',
  MasterDealerMailing = 'MasterDealerMailing',
  ProgramTypeCacheStore = 'ProgramTypeCacheStore',
  MPSSummary = 'MPSSummary',
  CountryManagerSummary = 'CountryManagerSummary',
  CountryManagerSummaryDistributors = 'FormCountryManagerSummaryDistributors',
  CountryManagerSummaryRetailers = 'FormCountryManagerSummaryRetailers',
  ExceptionalPartnerSpecialization = 'ExceptionalPartnerSpecialization',
  PBMList = 'PBMList',
  HistoricalResultsChartOptions = 'HistoricalResultsChartOptions',
  PSEndCustomers = 'PSEndCustomers',
  ActionsPlanMDF = 'ActionsPlanMDF',
  ActionsPlanMDFFYears = 'ActionsPlanMDFFYears',
  JBPCommercialCompletenessData = 'JBPCommercialCompletenessData',
  JBPCommercialCompletenessDataByPBM = 'JBPCommercialCompletenessDataByPBM',
  MasterDealerReport = 'MasterDealerReport',
  JBPExtendedPartnerTCAcceptanceReport = 'JBPExtendedPartnerTCAcceptanceReport',
  JBPSPKeyInitiatives = 'JBPSPKeyInitiatives',
  JBPKeyInitiatives = 'JBPKeyInitiatives',
  JBPMasterDealerBlockedPartners = 'JBPMasterDealerBlockedPartners',
  JBPBPExportFiles = 'JBPBPExportFiles',
  JBPSummaryAndAchivements = 'JBPSummaryAndAchivements',
  JBPActionCapabilities = 'JBPActionCapabilities',
  JBPTargetsMIFExport = 'JBPTargetsMIFExport',
  SalesTeamMngm = 'SalesTeamMngm',
  SalesTeamImport = 'SalesTeamImport',
  SalesTeamSRM = 'SalesTeamSRM',
  SalesTeamSRMData = 'SalesTeamSRMData',
  JBPExecutiveReport = 'JBPExecutiveReport',
  StrategicInitiative = 'StrategicInitiative',
  ActionPlans = 'ActionPlans',
  JBPLongTermStrategies = 'JBPLongTermStrategies',
  SalesTeamRequests = 'SalesTeamRequests',
  SalesTeamBusinessUnit = 'SalesTeamBusinessUnit',
  SalesTeamRoles = 'SalesTeamRoles',
  SalesTeamFilters = 'SalesTeamFilters',
  SOBResults = 'SOBResults',
  TopPartnerSummaryReport = 'TopPartnerSummaryReport',
  JBPMdfOpexFunds = 'JBPMdfOpexFunds',
  JBPNdpRate = 'JBPNdpRate',
  ActualsTargetsSettings = 'ActualsTargetsSettings',
  CloudCertifications = 'CloudCertifications',
  CloudCertificationsWithConnector = 'CloudCertificationsWithConnector',
  PBMManagers = 'PBMManagers',
  JBPDigitalAssessment = 'JBPDigitalAssessment',
  JBPDigitalAssessmentRecommendations = 'JBPDigitalAssessmentRecommendations',
  JBPOfferings = 'JBPOfferings',
  JBPOfferingsList = 'JBPOfferingsList',
  JBPPartnerAttachments = 'JBPPartnerAttachments',
  JBPCreditStatusInfo = 'JBPCreditStatusInfo',
  JBPMarketDeepDive = 'JBPMarketDeepDive',
  JBPSwotData = 'JBPSwotData',
  JBPReportType = 'JBPReportType',
  JBPTTAFormatType = 'JBPTTAFormatType',
  JBPPartnerScopeManagement = 'JBPPartnerScopeManagement',
  JBPTopPartnersToAdd = 'JBPTopPartnersToAdd',
  JBPGroupGeneralInfo = 'JBPGroupGeneralInfo',
  JBPPartnerGlobalGroups = 'JBPPartnerGlobalGroups',
  JBPTranslationFactors = 'JBPTranslationFactors',
  JBPTickets = 'JBPTickets',
  JBPSobTrendsPartnerSearch = 'JBPSobTrendsPartnerSearch',

  //ComposedReport
  JBPTargetCategoriesForTree = 'JBPTargetCategoriesForTree',
  JBPComposedReport = 'JBPComposedReport',
  JBPComposedReportFilters = 'JBPComposedReportFilters',
  JBPComposedReportClipBoard = 'JBPComposedReportClipBoard',
  JBPPBMs = 'JBPPBMs',
  JBPManagers = 'JBPManagers',
  JBPSpecializations = 'JBPSpecializations',
  JBPComposedReportPartnersScope = 'JBPComposedReportPartnersScope',

  // Common
  JBPMarketShare = 'JBPMarketShare',
  JBPDataInsight = 'JBPDataInsight',
  JBPPartnerDataDynamic = 'JBPPartnerDataDynamic',
  JBPPBMManagers = 'JBPPBMManagers',
  JBPPartnerStatistics = 'JBPPartnerStatistics',
  JBPPartnerGroups = 'JBPPartnerGroups',
  JBPPartnerGroupInfo = 'JBPPartnerGroupInfo', //extended with group info
  JBPPartnerGroupsExtData = 'JBPPartnerGroupsExtData', //extended with partner info
  JBPPGlobalPartnersEntities = 'JBPPGlobalPartnersEntities', //extended with partner info
  JBPCountMembersInGroup = 'JBPCountMembersInGroup',
  JBPGroupMembersString = 'JBPGroupMembersString',

  // Share of Business
  JBPShareOfBusiness = 'JBPShareOfBusiness',
  JBPHPPartnerShareOfBusiness = 'JBPHPPartnerShareOfBusiness',
  JBPSoBData = 'JBPSoBData',

  // Distributors
  JBPDistributorActionsPlan = 'JBPDistributorActionsPlan',
  JBPDistributorBridges = 'JBPDistributorBridges',
  JBPBusinessBridges = 'JBPBusinessBridges',
  JBPBridges = 'JBPBridges',
  JBPProductBridges = 'JBPProductBridges',
  JBPDistributorGroup = 'JBPDistributorGroup',
  JBPDistributorInventory = 'JBPDistributorInventory',
  JBPDistributorInventoryAmbition = 'JBPDistributorInventoryAmbition',
  JBPDistributorScope = 'JBPDistributorScope',
  JBPDistributorScopeData = 'JBPDistributorScopeData',
  JBPDistributorScopeDataDetails = 'JBPDistributorScopeDataDetails',
  JBPDistributorScopeDataSummary = 'JBPDistributorScopeDataSummary',

  // Retail
  JBPRetailGroup = 'JBPRetailGroup',
  JBPRetailMarketInfo = 'JBPRetailMarketInfo',

  // ELT
  JBPEltData = 'JBPEltData',
  JBPELTFinancialData = 'JBPELTFinancialData',
  JBPELTFinancialDataGroup = 'JBPELTFinancialDataGroup',
  JBPEltSearch = 'JBPEltSearch',
  JBPELTVersionsCount = 'JBPELTVersionsCount',
  JBPELTContacts = 'JBPELTContacts',
  JBPELTHPContacts = 'JBPELTHPContacts',

  //Global Partners
  JBPPartners = 'JBPPartners',
  JBPGlobalPartnerTableData = 'JBPGlobalPartnerTableData',
  JBPFetchPartnersToAdd = 'JBPFetchPartnersToAdd',
  JBPGlobalPartnerData = 'JBPGlobalPartnerData',
  JBPGlobalPartnerDetails = 'JBPGlobalPartnerDetails',
  JBPGlobalPartnerPartnersContacts = 'JBPGlobalPartnerPartnersContacts',
  JBPGlobalPartnerContacts = 'JBPGlobalPartnerContacts',
  JBPGlobalPartnerPartnerInfo = 'JBPGlobalPartnerPartnerInfo',
  //gp - initiatives
  JBPGPKeyInitiativesRollup = 'JBPGPKeyInitiativesRollup',
  //gp - long terms
  JBPGPLongTermsRollup = 'JBPGPLongTermsRollup',
  //gp - swot
  JbpSwotRollup = 'JbpSwotRollup',
}
